module.exports = __webpack_public_path__ + "static/media/8.ff1f8551.png";